import actionTypes from '../actions/actionTypes';

export default function snackbar(state = { messages: [] }, action) {
  let messages = state.messages;

  if(action.type == actionTypes.UPLOAD_AVATAR_FAIL) {
    messages.push({
      type: 'error',
      content: 'Upload failed! Maximum allowed image size is 1024x1024.'
    })
  }
  // if(action.type == actionTypes.LOGOUT_SUCCESS) {
  //   messages.push({
  //     type: 'success',
  //     content: 'You have been logged out!'
  //   });
  //   return { messages: messages };
  // }

  if(action.type == actionTypes.SAVE_ORGANIZATION_APPLICATION_DONE) {
    messages.push({
      type: 'success',
      content: 'You application has been received. Thank you!'
    });
    return { messages: messages };
  }
  if(action.type == actionTypes.SAVE_RECOMMENDED_RESOURCE_DONE) {
    messages.push({
      type: 'success',
      content: 'Recommendation recorded. Thank you!'
    });
    return { messages: messages };
  }

  if(action.type == actionTypes.SAVE_ME_DONE) {
    messages.push({
      type: 'success',
      content: 'Account information saved.'
    });
    return { messages: messages };
  }

  if(action.type == actionTypes.SAVE_MY_INTERESTS_DONE) {
    messages.push({
      type: 'success',
      content: 'Interests saved.'
    });
    return { messages: messages };
  }

  if(action.type == actionTypes.DELETE_FAVORITE_DONE) {
    messages.push({
      type: 'success',
      content: 'Favorite deleted.'
    });
    return { messages: messages };
  }

  if(action.type == actionTypes.DELETE_FAVORITE_FAIL) {
    messages.push({
      type: 'error',
      content: 'Could not delete favorite.'
    });
    return { messages: messages };
  }

  if(action.type == actionTypes.ADD_FAVORITE_DONE) {
    messages.push({
      type: 'success',
      content: 'Favorite added.'
    });
    return { messages: messages };
  }

  if(action.type == actionTypes.SAVE_ORGANIZATION_CLAIM_FAIL) {
    messages.push({
      type: 'error',
      content: 'Claim organization failed processing.'
    });
    return { messages: messages };
  }

  if(action.error && action.type == actionTypes.SAVE_ORGANIZATION_CLAIM_FAIL) {
    let  msg = {};
    if(action.error.status == 409 ) {
      msg.type = 'error',
      msg.content = 'You have already claimed one organization. You cannot not claim more';
    }
    messages.push(msg);
  }

  if(action.type.indexOf(actionTypes.SEND_VERIFICATION_EMAIL) != -1 &&  action.response) {
    messages.push({
      type: (action.response.data.error) ? 'error' : 'success',
      content: action.response.data.message
    });
  }

  if(action.type == actionTypes.EMAIL_VERIFICATION_DONE &&  action.response) {
    messages.push({
      type: 'success',
      content: "Your email has been verified."
    });
  }

  if(action.type == actionTypes.EMAIL_VERIFICATION_FAIL &&  action.response) {
    messages.push({
      type: 'error',
      content: "Something went wrong. Your email could not be verified."
    });
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/snackbar.js